import { render, staticRenderFns } from "./ellipsis-tooltip.vue?vue&type=template&id=97d05b42&"
import script from "./ellipsis-tooltip.vue?vue&type=script&lang=js&"
export * from "./ellipsis-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./ellipsis-tooltip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports